
export enum QuestType {
  KIDS,
  ADULTS,
  ALL
}
